import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchPrivacy = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group-policy/${subscriberGroupId}`);
    return res?.data?.data?.privacy_policy ?? "";
};

export const usePrivacy = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["privacy", subscriberGroupId],
        queryFn: () => fetchPrivacy(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        privacyPolicy: data ?? "",
        isLoading,
    };
};
